import React, { useState } from 'react'

import { SiteDataContext } from '../../components/page-wrapper'
import { getMicroCopy } from '../../utils/microcopy'
import ButtonNew from '../ButtonNew/ButtonNew'
import IconNew from '../IconNew'
import { NavLink } from '../helpers'
import { useMicroCopyData } from '@/src/context/MicroCopyContext'

export default function NotificationBar({ notifications }) {
  const microCopyData = useMicroCopyData()
  const { lang } = React.useContext(SiteDataContext)
  const [currentMessageNr, setCurrentMessageNr] = useState(1)

  const handleSetCurrentMessageNr = (nextNr) => {
    if (!notifications) return

    if (nextNr > notifications.length) {
      setCurrentMessageNr(1)
      return
    }
    if (nextNr < 1) {
      setCurrentMessageNr(notifications.length)
      return
    }

    setCurrentMessageNr(nextNr)
  }

  const sliderBtnAriaLabel = getMicroCopy({
    key: 'notificationsBar',
    fallback: 'Notification bar button',
    data: microCopyData[lang]
  })

  const setClass = (num) => {
    const classArr = ['c-notification-bar__notification-message']
    if (num === currentMessageNr) classArr.push('present')
    if (num > currentMessageNr) classArr.push('next')
    if (num < currentMessageNr) classArr.push('previous')
    return classArr.join(' ')
  }

  if (!notifications) {
    return null
  }

  return (
    <div className="c-notification-bar">
      <ButtonNew
        className="c-notification-bar__slider-button"
        onClick={() => handleSetCurrentMessageNr(currentMessageNr - 1)}
        variant={'tertiary'}
        size={'sm'}
        aria-label={sliderBtnAriaLabel}
      >
        <IconNew
          name="tabler-chevron-down"
          classes="c-notification-bar__slider-button__icon left"
          size={24}
        />
      </ButtonNew>
      <div className="c-notification-bar__notifications-container">
        {notifications.map(({ notificationMessage, url, accessibleText }, index) =>
          url && url !== '#' ? (
            <NavLink key={`notification-${index}`} to={url} className={setClass(index + 1)}>
              <span>{notificationMessage || ''}</span>
              {accessibleText && <span className="sr-only">{accessibleText}</span>}
            </NavLink>
          ) : (
            <div key={`notification-${index}`} className={setClass(index + 1)}>
              <span>{notificationMessage || ''}</span>
            </div>
          )
        )}
      </div>
      <ButtonNew
        className="c-notification-bar__slider-button"
        onClick={() => handleSetCurrentMessageNr(currentMessageNr + 1)}
        aria-label={sliderBtnAriaLabel}
        variant={'tertiary'}
        size={'sm'}
      >
        <IconNew
          name="tabler-chevron-down"
          classes="c-notification-bar__slider-button__icon right"
          size={24}
        />
      </ButtonNew>
    </div>
  )
}
